module.exports = __webpack_public_path__ + "img/guia-devolucao-passo-a-passo.5da580bb.png";